<template>
  <div class="">

    <div class="form-group d-none">
      <label>نوع</label>
      <select class="custom-select">
        <option>متن</option>
      </select>
    </div>

    <div class="form-group">
      <label>{{ item.name }}</label>
      <input type="text" v-model="item.value" class="form-control" placeholder="مقدار">
      <span class="badge badge-danger">کاراکتر: {{item.value.length}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SmsVariable",
  data() {
    return {
      form: {}
    }
  },
  props: {
    item: {}
  }
}
</script>

<style scoped>

</style>